import React, { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box/Box";
import GenieText from "../genie-text/GenieText";
import GenieLogo from "../../special/genie-logo/GenieLogo";

interface GenieProcessingProps {
  headerWidth?: number;
  phrases: string[];
}

const delay = (ms = 100) => new Promise((res) => setTimeout(res, ms));

function GenieProcessing({ headerWidth = 81, phrases }: GenieProcessingProps) {
  const phraseIndexRef = useRef(0);
  const letterIndexRef = useRef(0);

  useEffect(() => {
    setLetterIndex(letterIndexRef.current);
  }, [letterIndexRef.current]);

  useEffect(() => {
    setPhraseIndex(phraseIndexRef.current);
  }, [phraseIndexRef.current]);

  const [phraseIndex, setPhraseIndex] = useState(0);
  const [letterIndex, setLetterIndex] = useState(0);

  useEffect(() => {
    keystroke();
  }, []);

  const keystroke = async () => {
    if (phrases[phraseIndexRef.current].length > letterIndexRef.current) {
      letterIndexRef.current = letterIndexRef.current + 1;
    } else {
      letterIndexRef.current = 0;
      phraseIndexRef.current =
        phrases.length - 1 > phraseIndexRef.current
          ? phraseIndexRef.current + 1
          : 0;
      await delay(500);
    }
    await delay(100);
    setLetterIndex(letterIndexRef.current);
    setPhraseIndex(phraseIndexRef.current);
    await keystroke();
  };

  return (
    <Box
      width={"100%"}
      height={`calc(100vh - ${headerWidth}px)`}
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <Box
        width={"100%"}
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
      >
        <GenieLogo isSmall />
        <Box height={36} textAlign={"center"}>
          <GenieText>{phrases[phraseIndex].slice(0, letterIndex)}</GenieText>
        </Box>
      </Box>
    </Box>
  );
}

export default GenieProcessing;
